var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banIn"},[_c('div',{staticClass:"inImg"},[_c('img',{attrs:{"src":_vm.banImg,"alt":""}})]),_c('div',{staticClass:"inText flex-center color_f"},[_c('div',{staticClass:"wrap"},[_vm._t("text")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }